import React, { useEffect } from 'react'
import "./AboutUs.css"
import Header from '../Components/Header'
import storyImage from '../Assets/aboutmatrix.jpg'
import Footer from '../Components/Footer'

const AboutUs = () => {
  useEffect(()=>{
   window.scrollTo(0,0)
  },[])
  return (
    <>
      <Header/>
      
      {/* Hero Section */}
      <section className='About-hero'>
        <article className='About-hero-gap'>
          <div className='About-texts'>
            <h1 className='About-head-text'>
              A Global Ecosystem <br />Built on Unity
            </h1>
            <p className='About-sub-text'>
              CBGE is shaping a community-driven digital future by bringing citizens,
              enterprises, and institutions together to unlock large-scale opportunities.
            </p>
          </div>
        </article>
      </section>

      {/* Our Story Section */}
      <section className='our-story-section'>
        <div className='story-container'>
          <div className='story-content' data-aos="fade-up">
            <h2 className='story-title'>ABOUT COMPANY</h2>
            <p className='story-text'>
              Community Based Global Ecosystem (CBGE) is a signature process to map 
              and unite a community globally to position at strength.
            </p>
            <p className='story-text'>
              CBGE strives to build a community based global ecosystem for all the 
              Odia people from across the globe, connecting them through a single 
              platform. It provides an apt place for meaningful interactions, promote 
              businesses and enhance personal & professional growth. CBGE is designed 
              to encourage communications between people from various spheres of life 
              with varied experiences to share their commonalities and differences 
              through one digital platform.
            </p>
          </div>
          <div className='story-image-wrapper'>
            <img src={storyImage} alt='Team collaboration' className='story-image' />
          </div>
        </div>
      </section>

      {/* Vision and Mission Section */}
      <section className='vision-mission-section'>
        <div className='vision-mission-container'>
          <div className='vision-box' data-aos="fade-up">
            <h2 className='vm-title'>VISION</h2>
            <p className='vm-text'>
              To Build World's 1st Community Based Digital Citizens Directory.
            </p>
          </div>
          
          <div className='mission-box' data-aos="fade-up">
            <h2 className='vm-title'>MISSION</h2>
            <p className='vm-text'>
              'Unity For Enterprise' - to Establish a Community Based Global Ecosystem.
            </p>
          </div>
        </div>
      </section>
      <Footer/>
    </>
  )
}

export default AboutUs